export default __webpack_public_path__ + "static/media/stpay_logo_white.ea49b9f2.png";